var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-3 ma-3"},[_c('v-row',[_c('v-col',{attrs:{"cols":"3"}}),_c('v-col',{attrs:{"cols":"6"}},[_c('ReporteTiempoReal')],1),_c('v-col',{attrs:{"cols":"3"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }